"use client";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import * as chains from "viem/chains";

export const useGetExplorerUrl = () => {
  const { network } = useDynamicContext();
  if (!network) return null;
  const chain = Object.values(chains).find(({ id }) => id === Number(network));
  const baseUrl = chain?.blockExplorers?.default?.url;
  return baseUrl ? `${baseUrl}/tx/` : null;
};
